export default "__VITE_ASSET__c2fc361f__"